import styled from "@emotion/styled";
import { BACKGROUND_LIGHT, MID_GREY } from "src/constants/colors";
import { FilesIcon } from "src/assets/icons";

const FileIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background-color: ${BACKGROUND_LIGHT};
  border-radius: 8px;
`;

const FileImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  background-color: ${BACKGROUND_LIGHT};
`;

const FilePlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: ${MID_GREY};

  p {
    margin: 0;
    font-size: 14px;
  }
`;

interface FilePreviewContentProps {
  isLoading: boolean;
  isPdf: boolean;
  isImage: boolean;
  url: string | undefined;
  fileName: string;
  imageLoadError: boolean;
  onImageError: () => void;
}

export default ({
  isLoading,
  isPdf,
  isImage,
  url,
  fileName,
  imageLoadError,
  onImageError,
}: FilePreviewContentProps) => {
  if (isLoading) {
    return (
      <FilePlaceholder>
        <p>Loading preview...</p>
      </FilePlaceholder>
    );
  }

  if (isPdf && url) {
    return <FileIframe src={url} title={fileName} />;
  }

  if (isImage && url && !imageLoadError) {
    return <FileImage src={url} alt={fileName} onError={onImageError} />;
  }

  return (
    <FilePlaceholder>
      <FilesIcon />
      <p>
        {isImage && imageLoadError
          ? "Image failed to load"
          : "Preview not available"}
      </p>
    </FilePlaceholder>
  );
};
